import { Selection } from '../../../../../core/h3ml/state/fusion-state';
import { AbstractLayerState } from '../../../../../core/outputs/annotation/annotation-shared/state/layers/abstract-layer-state';
import { FocusedAreaRange } from '../../../../../core/outputs/annotation/annotation-shared/toolbars/focusable-scrubber/focusable-scrubber.utils';
import { Dimensions } from '../../../../../cross-team-shared/types/misc';
import { InFlightExtrapolationRequest } from '../../../../../team-apis/content/in-flight-extrapolation-request';
import { Point2D } from '../../../../../team-apis/otterdam/answers/shape-typings';

export type Status = 'loading' | 'error' | 'ready';
export type ViewMode = 'layers' | 'all' | 'selected' | 'none';

interface BulkRemovePreferences {
  includeKeyFrames: boolean;
  includeDynamicTags: boolean;
  keyframeToPreserveOnDeletion: 'first' | 'last';
}

export class AnnotationState {
  activeLayerIndex = 0;
  // Could refactor to Annotation Layout Transient
  mainDisplaySize?: Dimensions;
  errorMessage!: string;
  focus?: 'main' | 'zoomPanel';
  frameNumber = 0;
  layers: AbstractLayerState[] = [];
  status: Status = 'loading';
  inFlightMlExtrapolationRequests: InFlightExtrapolationRequest[] = [];
  bulkRemovePreferences: BulkRemovePreferences = {
    includeKeyFrames: false,
    includeDynamicTags: false,
    keyframeToPreserveOnDeletion: 'first',
  };
  focusedAreaRange?: FocusedAreaRange;
  mousePosition?: { clientPoint: Point2D; imagePoint: Point2D };
  zoomPanel: {
    scale?: number;
    enabled: boolean;
    isOpen: boolean;
    manuallyOpened: boolean;
  } = {
    enabled: true,
    isOpen: false,
    manuallyOpened: false,
  };
}

export function getFocusedShapeIndex(selection: Selection) {
  const selectedShapeIndexes = Object.keys(selection);
  if (selectedShapeIndexes.length === 1) {
    return Number(selectedShapeIndexes[0]);
  } else {
    return undefined;
  }
}
